import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { House, Camera, DropHalfBottom, Flask } from '@phosphor-icons/react';

const BottomNavigation = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const currentPath = location.pathname;

    const navItems = [
        { path: '/home', label: 'خانه', icon: House },
        { path: '/scanpage', label: 'درموآنالیز', icon: Camera },
        { path: '/routine', label: 'درمو روتین', icon: DropHalfBottom },
        { path: '/profitscan', label: 'درموفیت', icon: Flask },
    ];

    return (
        <nav className="bottom-nav" dir="rtl">
            <div className="flex justify-around items-center max-w-md mx-auto">
                {navItems.map((item) => {
                    const IconComponent = item.icon;
                    const isActive = currentPath === item.path;
                    return (
                        <button
                            key={item.path}
                            data-tour={`nav-${item.path.replace('/', '')}`}
                            onClick={() => navigate(item.path)}
                            className={`bottom-nav-item ${isActive ? 'active' : ''}`}
                        >
                            <IconComponent 
                                size={24} 
                                weight={isActive ? "fill" : "regular"} 
                            />
                            <span className="text-xs font-medium">{item.label}</span>
                        </button>
                    );
                })}
            </div>
        </nav>
    );
};

export default BottomNavigation; 